interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionText?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionText,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="w-full flex flex-col items-center justify-center py-16 px-4 text-center animate-fade-in">
      <div className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className={`${icon} text-3xl`}></i>
      </div>
      <p className="mt-4 text-base font-medium text-foreground-800">{title}</p>
      {description ? (
        <p className="mt-1.5 text-sm text-foreground-500 max-w-md">{description}</p>
      ) : null}
      {actionText && onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 px-5 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
        >
          {actionText}
        </button>
      ) : null}
    </div>
  );
}